import { createContentPropTypes } from '../../../helpers/content';

const content = {
	title: 'Payment details',
	fromLabel: 'From',
	toLabel: 'To',
	amountLabel: 'Amount',
	refLabel: 'Reference',
	createdByLabel: 'Created by',
	createdOnLabel: 'Created on',
	frequencyLabel: 'Frequency',
	stopPaymentLabel: 'Stop payment',
	startDateLabel: 'Start date',
	stopsWhenItIsCancelled: 'When it is cancelled',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
